import styled from 'styled-components/macro'
import { ColorsMap, FontWeightMap } from '@/utils/Theme'

export const TagName = styled.div`
  padding: 0.15rem 0.8rem;
  background-color: ${ColorsMap.primary};
  color: ${ColorsMap.white};
  text-transform: uppercase;
  font-weight: ${FontWeightMap.bold};
`
export const TagTriangle = styled.div`
  width: 0;
  height: 0;
  border-right: 0 solid transparent;
  border-left: 0.5rem solid transparent;
  border-top: 0.5rem solid ${ColorsMap.textDefault};
`
